// extracted by mini-css-extract-plugin
export default {"title":"S8-z","warning":"T8-z","sizeOptionsLegendText":"U8-z"};